import { call, put } from 'redux-saga/effects';
import { setUserAnalyticData } from '../../../../state/analytic/analyticUserDataSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchUserDataSaga(action) {
    const { uid, range, startDate, endDate } = action.payload || {};
    try {
        const params = { range };
        if (range === 'custom' && startDate && endDate) {
            params.startDate = new Date(startDate).toISOString();
            params.endDate = new Date(endDate).toISOString();
        }
        const { data } = yield call(
            [backendClient, backendClient.get],
            `analytics/users/${encodeURIComponent(uid)}`,
            { params }
        );
        yield put(setUserAnalyticData({ uid, range, calls: data?.calls || [] }));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch user analytic data', status, err?.message);
    }
}